// Note: The first file of a module here, must also register the module

import "./organisation-settings.component";
import "./organisation-user-licenses-dialog.component";
import "./update-user-url-text-dialog.component";
